import { READ_ONLY_MODE } from "Areas/Documents/documentDetails/types/readOnlyMode";
import Menu from "Components/menu";
import classNames from "classnames";
import get from "lodash/get";
import isNil from "lodash/isNil";
import map from "lodash/map";
import React, { useCallback, useEffect, useMemo } from "react";
import { ITEM_SIZES, NAV_CENTERED_CONTENT_CLASS_NAME, NAV_ITEM_ACTION_PANEL_CLASS_NAME, NAV_MB_DEFAULT_GAP_CLASS_NAME, SidebarMenuItem, SidebarMenuList } from "../../Common";
import buildDocumentActionsMenuItems from "../utils/buildDocumentActionsMenuItems";
import buildDocumentSidebarItems, { buildDocumentKey } from "../utils/buildDocumentSidebarItems";
import locale from "./tabDocuments.locale";
import styles from "./tabDocuments.module.css";
export default function TabDocuments(props) {
    useEffect(() => {
        props.projectId && props.onInitialized && props.onInitialized(props.projectId);
    }, [props.onInitialized, props.projectId]);
    const addBtn = useMemo(() => {
        if (!props.canEditDocuments)
            return undefined;
        const e = new SidebarMenuItem("add-document", locale.ADD_DOCUMENT, "icon-add font-h3 text-primary-new");
        e.className = classNames(styles["add-btn"], styles["menu-item"], NAV_MB_DEFAULT_GAP_CLASS_NAME, NAV_CENTERED_CONTENT_CLASS_NAME);
        return e;
    }, []);
    const sidebarMenuItems = useMemo(() => buildDocumentSidebarItems(props.documents, (document) => (React.createElement(Menu, { key: "menu", togglerClassName: "no-border no-default-colors animate-hover-color", togglerIconClassName: "icon-dots", togglerWidth: ITEM_SIZES.MIN_ACTION_ELEMENT_SIZE, togglerHeight: ITEM_SIZES.MIN_ACTION_ELEMENT_SIZE, items: buildDocumentActionsMenuItems(props.projectId, document, props.onOpenDocumentEditorPanel, props.onDeleteDocument, props.onSetDocumentSelected, props.canOpen, props.canEditDocuments, props.canDeleteDocuments) }))), [
        props.projectId,
        props.documents,
        props.onOpenDocumentEditorPanel,
        props.onDeleteDocument,
        props.onSetDocumentSelected
    ]);
    const selectedItems = useMemo(() => new Set(map(props.selectedDocumentIds, buildDocumentKey)), [props.selectedDocumentIds]);
    const activeItems = useMemo(() => new Set(props.activeDocumentId ? [buildDocumentKey(props.activeDocumentId)] : []), [props.activeDocumentId]);
    const handleItemClick = useCallback((item) => {
        if (addBtn && item.key === addBtn.key) {
            !isNil(props.projectId) &&
                props.onOpenDocumentCreatorPanel &&
                props.onOpenDocumentCreatorPanel(props.projectId);
        }
    }, [props.onOpenDocumentCreatorPanel, props.projectId, addBtn]);
    const handleItemDoubleClick = useCallback((item, evt) => {
        if (item.sourceData &&
            !isNil(props.projectId) &&
            props.onSetDocumentSelected &&
            props.canOpen &&
            props.canOpen(item.sourceData.Id, props.projectId)) {
            const target = get(evt, "event.originalEvent.currentTarget", get(evt, "currentTarget"));
            if (target && target.closest(`.${NAV_ITEM_ACTION_PANEL_CLASS_NAME}`))
                return;
            props.onSetDocumentSelected(item.sourceData.Id, true, item.selected ? undefined : READ_ONLY_MODE.AUTO);
        }
    }, [props.projectId, props.onSetDocumentSelected, props.canOpen]);
    useEffect(() => {
        if (props.selectedDocumentIds &&
            props.selectedDocumentIds.length === 0 &&
            props.documents &&
            props.documents.length > 0 &&
            props.onSetDocumentSelected) {
            const sortedDocuments = [...props.documents].sort((a, b) => {
                const aValue = a.Name;
                const bValue = b.Name;
                if (props.sortOrder === "asc") {
                    return aValue > bValue ? 1 : -1;
                }
                return aValue < bValue ? 1 : -1;
            });
            const firstDocument = sortedDocuments[0];
            props.onSetDocumentSelected(firstDocument.Id, true, READ_ONLY_MODE.AUTO);
        }
    }, [props.selectedDocumentIds, props.documents, props.onSetDocumentSelected]);
    return (React.createElement(SidebarMenuList, { className: props.className, bgColorDefault: props.bgColorDefault, bgColorActive: props.bgColorActive, inProgress: !props.documents ? props.inProgress : false, sidebarMenuItems: sidebarMenuItems, sidebarMenuButton: addBtn, selectedItems: selectedItems, activeItems: activeItems, onItemClick: handleItemClick, onItemDoubleClick: handleItemDoubleClick, filterText: props.filterText, sortBy: props.sortBy, sortOrder: props.sortOrder }));
}
